import { Button, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { useState } from "react";
import { createEntityStore, UseEntityStore } from "../../common/entityStore";
import { propDateField } from "../../common/entityStoreForm";
import { propRequired, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { CustomerDto, OrderRetentionSaveDto } from "./types";
import { DateField } from "../../common/form";
import { dayjs } from "../../common/config";

export const OrderShipmentDueDateDialog = (props: {
    close: () => void;
    ordId: number;
    shipment: {
        id: number;
        shpId: number;
        invcId: string;
        shpDte: string;
        invcDte: string;
        dueDte: string;
    };
    onUpdated(data: { dueDte: string; }): void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    product: string;
    project: string;
    retention: OrderRetentionSaveDto | undefined;
    clearRetention(): void;
}) => {
    const customer = props.useCustomerStore(p => ({ custId: p.clientData.custId }));
    const [{ useStore }] = useState(() => {
        const useStore = createEntityStore<OrderShipmentDto>({
            data: {
                dueDteCurrent: props.shipment.dueDte,
                dueDte: props.shipment.dueDte,
                retention: props.retention,
            },
            path: `customers/orderShipments/${props.shipment.id}/dueDate`,
            fetchOnInit: false,
            saveProps: ["dueDte", "retention"],
            onSaved(data) {
                props.clearRetention();
                useStore.getState().setClientDataProp("retention", undefined);
                props.onUpdated({ dueDte: data.dueDte });
                props.close();
            },
            propValidators: [
                propValidValue("dueDte", "dueDteFormatted"),
                propRequired("dueDte"),
                propValueValidator("dueDte", (p, e) => p != null && dayjs.tz(p) < dayjs.tz(e.dueDteCurrent) && "New due date cannot be before current due date."),
            ]
        });
        return { useStore };
    });
    const { save, isSaveDisabled } = useStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{`Edit due date - ${props.shipment.invcId}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={6}><TextField value={customer.custId} label="Customer" InputProps={{ disabled: true }} /></Grid>
                <Grid item xs={6}><TextField value={props.ordId} label="Order" InputProps={{ disabled: true }} /></Grid>
                <Grid item xs={12}><TextField value={props.product} label="Product" InputProps={{ disabled: true }} /></Grid>
                <Grid item xs={12}><TextField value={props.project} label="Project" InputProps={{ disabled: true }} /></Grid>
                <Grid item xs={6}><DateField value={props.shipment.shpDte} label="Delivery date" disabled={true} /></Grid>
                <Grid item xs={6}><DateField value={props.shipment.invcDte} label="Invoice date" disabled={true} /></Grid>
                <Grid item xs={6}>{propDateField(useStore)("dueDteCurrent", null, "Current due date", { disabled: true })}</Grid>
                <Grid item xs={6}>{propDateField(useStore)("dueDte", "dueDteFormatted", "New due date")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button disabled={isSaveDisabled} onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};

interface OrderShipmentDto {
    dueDteCurrent: string;
    dueDte: string;
    dueDteFormatted?: string;
    retention: OrderRetentionSaveDto | undefined;
}
